<template>
  <div id="menu" class="menu-page">
    <section class="menu-wrap">
      <div class="menu-overlay">
        <div class="menu-content">
          <!-- Logo superior -->
          <div class="logo-top text-center" data-aos="fade-down" data-aos-delay="100">
            <img
              src="../assets/imgs/dominos/dominos-logo-interior.png"
              alt="Domino's"
              class="logo-dominos"
            />
          </div>

          <!-- Título -->
          <div class="title-wrap" data-aos="fade-up" data-aos-delay="150">
            <h1 class="menu-title">¿Qué deseas hacer?</h1>
          </div>

          <!-- Opciones -->
          <nav class="menu-links" data-aos="fade-up" data-aos-delay="220">
            <router-link to="/dashboard" class="menu-item">
              <img
                src="../assets/imgs/dominos/icono-registrar-ticket.png"
                alt="Registrar un ticket"
                class="menu-icon"
              />
              <span class="menu-text">Registrar un ticket</span>
            </router-link>

            <router-link to="/mis-participaciones" class="menu-item">
              <img
                src="../assets/imgs/dominos/icono-ver-mis-puntos.png"
                alt="Ver mis puntos acumulados"
                class="menu-icon"
              />
              <span class="menu-text">Ver mis puntos acumulados</span>
            </router-link>

            <router-link to="/ganadores" class="menu-item">
              <img
                src="../assets/imgs/dominos/icono-consultar-ganadores.png"
                alt="Consultar ganadores"
                class="menu-icon"
              />
              <span class="menu-text">Consultar ganadores</span>
            </router-link>

            <button type="button" class="menu-item menu-btn" @click="logout()">
              <img
                src="../assets/imgs/dominos/icono-cerrar-sesion.png"
                alt="Cerrar sesión"
                class="menu-icon"
              />
              <span class="menu-text">Cerrar sesión</span>
            </button>

            <a
              href="/tyc.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="menu-item"
            >
              <img
                src="../assets/imgs/dominos/icono-terminos-y-condiciones.png"
                alt="Ver Términos y Condiciones"
                class="menu-icon"
              />
              <span class="menu-text">Ver Términos y Condiciones</span>
            </a>
          </nav>
        </div>
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    />

    <Footer />
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import Footer from "@/components/Footer";
import AOS from "aos";
import { mapState } from "vuex";

export default {
  name: "MenuDominos",
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      showPasswordReset: false,
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return this.userProfile && Object.keys(this.userProfile).length > 0;
    },
  },
  mounted() {
    AOS.init({
      offset: 0,
      delay: 0,
      duration: 700,
      easing: "ease-in-out",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
      disable: "mobile",
    });
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
  },
};
</script>

<style scoped>
.menu-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #e30613;
}

.menu-wrap {
  min-height: 100vh;
  background-image: url("../assets/imgs/dominos/bg-menu.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  position: relative;
}

.menu-overlay {
  min-height: 100vh;
  width: 100%;
  background: rgba(227, 6, 19, 0.12);
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.menu-content {
  width: 100%;
  max-width: 430px;
  min-height: 100vh;
  padding: 26px 28px 50px 28px;
  display: flex;
  flex-direction: column;
}

.logo-top {
  padding-top: 6px;
  margin-bottom: 22px;
}

.logo-dominos {
  width: 84px;
  max-width: 100%;
  height: auto;
}

.title-wrap {
  margin-bottom: 26px;
}

.menu-title {
  margin: 0;
  color: #ffffff;
  font-weight: 900;
  font-size: 2.15rem;
  line-height: 1.05;
  text-align: left;
  letter-spacing: -0.3px;
}

.menu-links {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.menu-item {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #ffffff !important;
  gap: 14px;
  width: 100%;
}

.menu-item:hover {
  text-decoration: none;
  color: #ffffff !important;
  opacity: 0.96;
}

.menu-btn {
  background: transparent;
  border: 0;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.menu-icon {
  width: 26px;
  min-width: 26px;
  height: 26px;
  object-fit: contain;
  display: block;
}

.menu-text {
  color: #ffffff;
  font-size: 1.45rem;
  line-height: 1.1;
  font-weight: 800;
  text-align: left;
  max-width: 250px;
}

/* Tablet / desktop */
@media (min-width: 768px) {
  .menu-content {
    max-width: 520px;
    padding: 34px 40px 60px 40px;
  }

  .logo-dominos {
    width: 96px;
  }

  .menu-title {
    font-size: 2.55rem;
  }

  .menu-links {
    gap: 26px;
  }

  .menu-icon {
    width: 30px;
    min-width: 30px;
    height: 30px;
  }

  .menu-text {
    font-size: 1.6rem;
    max-width: 320px;
  }
}

/* Si lo quieres más parecido al screenshot en móvil angosto */
@media (max-width: 420px) {
  .menu-content {
    padding: 20px 16px 40px 16px;
  }

  .logo-dominos {
    width: 76px;
  }

  .menu-title {
    font-size: 1.95rem;
  }

  .menu-links {
    gap: 20px;
  }

  .menu-icon {
    width: 24px;
    min-width: 24px;
    height: 24px;
  }

  .menu-text {
    font-size: 1.28rem;
    max-width: 220px;
  }
}
</style>